module.exports = __webpack_public_path__ + "media/images/pepsi_digin_day/support-icon-f2f1357ba49c832591137aa99c4db7f1.png";